import { useAuthenticatedMutation, useAuthenticatedQuery } from 'client/hooks';
import { useAppState } from 'client/providers/AppProvider';
import {
    Espin_Profile_View_Type_Enum,
    GetAllProfileViewDataForHighSchoolsQuery,
    GetAllProfileViewDataForHighSchoolsQueryVariables,
    GetAllProfileViewDataForHighSchoolsDocument,
    FollowMutation,
    FollowMutationVariables,
    FollowDocument,
    UnfollowMutation,
    UnfollowMutationVariables,
    UnfollowDocument,
    Espin_Follow_Type_Enum,
} from 'generated/spin-graphql';
import React, { useCallback, useMemo } from 'react';
import { gql } from 'urql';
import { ProfileViews } from './ProfileViews';
gql`
    query GetAllProfileViewDataForHighSchools($id: uuid!, $vt: [espin_profile_view_type_enum!], $date: timestamptz) {
        espin_follow(where: { high_school_id: { _eq: $id }, follow_type: { _eq: high_school_follows_college } }) {
            college_id
        }
        espin_profile_view(
            where: { high_school_id: { _eq: $id }, profile_view_type: { _in: $vt } }
            order_by: { created_at: desc }
        ) {
            id
            ...ProfileViews
        }
        espin_profile_view_aggregate(
            where: { high_school_id: { _eq: $id }, profile_view_type: { _in: $vt }, created_at: { _gt: $date } }
        ) {
            aggregate {
                count
            }
        }
    }
`;
const backUpDate = new Date().toISOString();
const HighSchoolProfileViews = () => {
    const { user } = useAppState();

    const { isReady, data } = useAuthenticatedQuery<
        GetAllProfileViewDataForHighSchoolsQuery,
        GetAllProfileViewDataForHighSchoolsQueryVariables
    >(
        {
            query: GetAllProfileViewDataForHighSchoolsDocument,
            variables: {
                id: user?.high_school_profile?.high_school?.id,
                vt: [Espin_Profile_View_Type_Enum.CollegeViewsHighSchool],
                date: user.last_login ?? backUpDate,
            },
            pause: !user,
        },
        ['espin_follow'],
    );
    const [_, followCollege] = useAuthenticatedMutation<FollowMutation, FollowMutationVariables>(FollowDocument);

    const [__, unfollowCollege] = useAuthenticatedMutation<UnfollowMutation, UnfollowMutationVariables>(
        UnfollowDocument,
    );
    const onFollow = useCallback(
        (userId: string) => {
            followCollege(
                {
                    input: {
                        college_id: userId,
                        high_school_id: user?.high_school_profile?.high_school?.id,
                    },
                },
                { additionalTypenames: ['espin_follow'] },
            );
        },
        [followCollege, user?.high_school_profile?.high_school?.id],
    );

    const onUnfollow = useCallback(
        (userId: string) => {
            unfollowCollege(
                {
                    where: {
                        college_id: { _eq: userId },
                        high_school_id: { _eq: user?.high_school_profile?.high_school?.id },
                        follow_type: { _eq: Espin_Follow_Type_Enum.HighSchoolFollowsCollege },
                    },
                },
                { additionalTypenames: ['espin_follow'] },
            );
        },
        [unfollowCollege, user?.high_school_profile?.high_school?.id],
    );
    const listOfFollows = useMemo(() => data?.espin_follow.map((f) => f.college_id), [data]);

    return (
        <div>
            {isReady && (
                <ProfileViews
                    listOfFollows={listOfFollows}
                    profileViews={data?.espin_profile_view}
                    totalViews={data?.espin_profile_view.length}
                    newViews={data?.espin_profile_view_aggregate.aggregate.count}
                    onFollow={onFollow}
                    onUnfollow={onUnfollow}
                />
            )}
        </div>
    );
};
export default HighSchoolProfileViews;
